import { render, staticRenderFns } from "./ClotureView.vue?vue&type=template&id=598aa95f&"
import script from "./ClotureView.vue?vue&type=script&lang=js&"
export * from "./ClotureView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports